module.exports = __webpack_public_path__ + "static/media/Add SIKI Coins.8d270562.svg";